<footer class="relative w-full overflow-hidden  bottom-0 inset-x-0 z-10">
  <div class="flex flex-col-reverse  md:flex-row w-full min-h-[320px] items-stretch border-t-2 border-primary-500">
    <div class="w-full md:w-5/12 p-10 md:p-12 flex flex-col space-y-6 bg-white  !text-gray-900  ">
      <div class="flex items-start space-x-6">
        <img src="/assets/images/emblem.png" alt="Coat of Arms" class="h-24 flex-shrink-0"/>
        <div>
          <h2 class="text-2xl font-bold">{{ "The United Republic of Tanzania."|concat|translate }}</h2>
          <div class="border-b-2 border-secondary-500 w-16 z-10"></div>
          <h3
            class="text-2xl font-bold text-primary-700  mt-1"> {{ 'Tanzania Government Services Directory.'|concat|translate }}</h3>
          <p class="leading-relaxed">
            {{ "Ni mpango wa serikali wa kurahisisha utoaji huduma kwa umma. Mpango huu unahusisisha kuainisha huduma zote zinazotolewa na taasisi za umma pamoja na             mahitaji yake na kuyaweka wazi kwa wananchi pindi wanapo pata huduma husika."|concat|translate }}
          </p>
        </div>
      </div>

      <div
        class="border-t border-gray-300 pt-4 text-sm flex flex-col md:flex-row md:space-x-6 space-y-2 md:space-y-0   text-gray-900">
        <span>{{ "Hakimiliki"|concat|translate }} © {{ currentYear }}. {{ "Haki zote zimehifadhiwa."|concat|translate }}</span>
        <div class="border-r-2 border-primary-500 h-4 mx-4 z-10"></div>
        <a href="/privacy-policy" class="hover:underline">{{ 'Sera ya faragha'|concat|translate }}</a>
        <div class="border-r-2 border-primary-500 h-4 mx-4 z-10"></div>
        <a href="/terms-and-conditions" class="hover:underline">{{ 'Vigezo na masharti'|concat|translate }}</a>
      </div>
    </div>
    <div class="w-full md:w-7/12 p-10 md:pl-20 md:pr-12 relative  text-white">
      <img src="/assets/images/footer-bg2.jpg"
           alt=""
           class="absolute inset-0 -z-10 w-full h-full  mix-blend-screen  object-cover">

      <img src="/assets/images/footer-bg-3.png"
           alt=""
           class="absolute inset-0 -z-10 w-full h-full hidden md:!inline-block  object-fill">

      <div class="bg-[#0E205EE5] inline-block md:!hidden absolute inset-0 -z-10"></div>

      <div class="flex flex-col md:flex-row md:justify-center md:space-x-12 z-10">
        <div class="space-y-4">
          <h4 class="text-lg font-semibold border-b border-white/40 pb-1">{{ 'Wasiliana nasi' |concat|translate }}</h4>
          <div class="mt-2 space-y-2 text-sm  flex flex-col gap-1" *ngIf="contactUs$|async as contactUs">
            @if (!contactUs?.length) {
              <div>{{ "Ofisi ya Rais, Mamlaka ya Serikari Mtandao"|concat|translate }}</div>
              <div>{{ "Mtumba-Mtaa wa Mtandao" |concat|translate }}</div>
              <div>S.L.P. 2833, 40404 DODOMA</div>
              <div class="flex items-center">{{ 'Barua pepe'|concat|translate }}: <a href="mailto:info@ega.go.tz">info&#64;ega.go.tz</a>
              </div>
            } @else {
              @for (contact of contactUs; track contact) {
                <div class=" flex flex-col gap-1">
                  @for (item of getContactItemLists(contact); track item) {
                    <div [innerHtml]="item"></div>
                  }
                </div>
              }
            }
          </div>
        </div>
        <div class="space-y-4 mt-10 md:mt-0">
          <h4 class="text-lg font-semibold border-b border-white/40 pb-1">{{ 'Tovuti Mashuhuri'|concat|translate }}</h4>
          <div class="mt-2 space-y-2 text-sm " *ngIf="relatedSites$ | async as relatedSites">
            @for (site of relatedSites; track site) {
              <div class="flex items-center gap-2">
                <mat-icon svgIcon="link"></mat-icon>
                <a href="{{site?.url}}" target="_blank">{{ site?.title }}</a></div>
            }
          </div>
        </div>
      </div>
    </div>
  </div>
</footer>
